export interface WhatsappCodeServiceGetNumbersParams {
    page?: number;
    per_page?: number;
    order_by?: string;
    search?: string;
}

export interface WhatsappCodeServiceGetCodesParams {
    page?: number;
    per_page?: number;
    order_by?: string;
}
